import { extendObservable, computed } from 'mobx'

import { employeeApi, clientContactApi, contractApi, getOfficeSuggestions } from '@atheneum/api'

class ProjectFormStore {
  constructor (staticData, userStore, project, singleContact) {
    const { EMPLOYEE_POSITIONS } = staticData.CONST

    extendObservable(this, {
      staticData,
      userStore,
      project,
      singleContact,
      loading: true,
      clientOptions: [],
      preferredClientLanguages: [],
      parentAccountId: this.getParentAccountId(project, singleContact),
      employees: [],
      bdManagerEmployees: computed(() => {
        const positions = [
          EMPLOYEE_POSITIONS.BD,
          EMPLOYEE_POSITIONS.ACCOUNT_MANAGER,
          EMPLOYEE_POSITIONS.EXECUTIVE,
          EMPLOYEE_POSITIONS.PRINCIPAL
        ]
        return this.employees.filter(e => positions.includes(e.positionId))
      })
    })

    this.init()
  }

  async init () {
    await this.loadEmployees()
    await this.loadClientPreferredLanguages()
    this.loading = false
  }

  loadEmployees () {
    return employeeApi.getAll().then(employees => {
      employees = employees
        .filter(e=>e.currentPosition)
        .map(e => {
          return {
            id: e.id,
            fullName: e.fullName,
            active: !!e.status,
            positionId: e.currentPosition.employeePositionId
          }
        })
        .filter(e => e.active)
      this.employees.replace(employees)
    })
  }

  loadClientPreferredLanguages () {
    const languages = this.staticData.languages.map(language => {
      return {
        id: language.id,
        name: language.name
      }
    })
    this.preferredClientLanguages.replace(languages)
  }

  async getOfficeSuggestions (officeString, projectId) {
    return getOfficeSuggestions(officeString, {
      projectId
    })
  }

  getClientOptions (searchString = '') {
    // this check is because if i lost focus from client contact, this method is executed and i dont want to send request to database
    if (!searchString) {
      return []
    }

    const query = {
      parentAccount: this.parentAccountId || 0,
      status: 'active',
      searchString
    }

    return clientContactApi.getClientContacts(query).then(res => {
      const clients = res.rows.map(client => {
        return {
          id: client.id,
          fullName: client.fullName,
          office: client.client.office
        }
      })

      this.clientOptions.replace(clients)
      return clients
    })
  }

  getParentAccountId (project, singleContact) {
    let parentAccountId = ''
    if (singleContact) {
      parentAccountId = singleContact.client.account.parentAccountId
    }
    if (project) {
      parentAccountId = project.platformClientId || project.parentAccountId
    }
    return Number(parentAccountId)
  }

  getAccountContracts (accountId) {
    return contractApi.getAccountContracts(accountId)
  }
}

export default ProjectFormStore
